/**
 * @file  routes/baseConfig.ts
 * @description  defines base route configuration for shareable components
 * @author ogarcia (ozkary)
 *
 */

/**
 * @description add each route to component mappig below.
 */
const basePath = '';

const routes = [
  {
    path: ['/customer'],
    exact: true,
    component: `${basePath}/Customer`
  },
  {
    path: ['/payment'],
    exact: true,
    component: `${basePath}/Payment`
  },
  {
    path: ['/review'],
    exact: true,
    component: `${basePath}/Review`
  },
  {
    path: ['/checkout'],
    exact: true,
    component: `${basePath}/Checkout`
  },
  {
    path: ['/receipt'],
    exact: true,
    component: `${basePath}/Receipt`
  },
  {
    path: ['/end'],
    exact: true,
    component: `${basePath}/End`
  },
  {
    path: '',
    exact: false,
    component: `${basePath}/NotFound`
  }
];

// export the route mapping
export default routes;

/**
 * list of restricted routes which require a session state to be able to visit them
 */
export const restrictedRoutes = ['/coverage', '/payment', '/checkout', '/customer', '/review'];

/**
 * Use this to check if a route path is in the restricted list of routes. T
 * @param name the current route path
 * @returns true if the route is restricted
 */
export const isRouteRestricted = async(path: string) : Promise<boolean> => {
  return restrictedRoutes.includes(path);
};
